import { login } from '@kk/h5-sdk';
import { store } from '@/store';
import { computed } from 'vue';
import { globalData } from '@/global';

export function useLogin () {
  const isLogin = computed(() => Boolean(store.state.user.uid));

  function loginFn () {
    if (!isLogin.value && globalData.isKuaikan) {
      login({
        // 使用半屏登录
        type: 1,
        title: '组队赚KK币',
        callback: (res: {
          data: { path_step: number; is_success_login: boolean };
        }) => {
          const { path_step, is_success_login } = res.data;
          if (path_step) {
            if (is_success_login) {
              location.replace(location.href.split('#')[0]);
            }
          }
        },
      });
    }
  }
  function clickLogin () {
    if (isLogin.value && globalData.isKuaikan) {
      return true;
    }
    loginFn();
  }
  return { loginFn, clickLogin };
}
